module.exports = __webpack_public_path__ + "static/assets/f0f9f818bc9fff5dc6f30f34cb1cc156.svg";